import { createElement } from '@max/max';
import View from '@hfe/max-view';
import { LIST_STATUS, SHOW_TYPE } from './types';
import ScrollView from '@hfe/max-scrollview';
import { toPx } from '@max/leez-style-util';
import './index.scss';
import Sensor from '@max/mbc-sensor';
import { LoadingMore } from './loading-more';
const NoMoreImageConfig = {
    uri: 'https://p0.meituan.net/ingee/4389c4e1268e625401921d052189d50b8549.png',
    width: toPx(126 / 2),
    height: toPx(27 / 2)
};
function ListContainer(props) {
    const { vo, feConfig, listStatus, loadMoreStatus, loadMoreType, onCardShow, onCardClick, isLastPage, onLoadMore, onContainerShow, showType, ChildComponent, listContainerStyle } = props;
    return <Sensor className="list-container" style={listContainerStyle ?? {}} onAppear={() => {
        onContainerShow();
    }} once>
      
      <View x-if={listStatus === LIST_STATUS.LOADING} className="list-container--loading">
        
      </View>
      <View x-if={vo?.list?.length > 0} className="list-container--success">
        <View x-if={showType === SHOW_TYPE.VERTICAL_DOUBLE} className="list-container--success-vertical">
          {vo?.list?.map((voItem, index) => <View className="list-container__item--vertical" key={voItem.id}>
              <ChildComponent key={voItem.id} vo={voItem} feConfig={feConfig} index={index} onCardClick={onCardClick} onCardShow={onCardShow}/>
            </View>)}
          <LoadingMore loadMoreStatus={loadMoreStatus} loadMoreType={loadMoreType} onLoadMore={onLoadMore} showType={showType} isLastPage={isLastPage}/>
        </View>
        <View x-if={showType === SHOW_TYPE.HORIZONTAL} className="list-container--success-horizontal">
          <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
            {vo?.list?.map((voItem, index) => <View className="list-container__item--horizontal" key={voItem.id}>
                <ChildComponent key={voItem.id} vo={voItem} feConfig={feConfig} index={index} onCardClick={onCardClick} onCardShow={onCardShow}/>
              </View>)}
            <LoadingMore loadMoreStatus={loadMoreStatus} loadMoreType={loadMoreType} onLoadMore={onLoadMore} showType={showType} isLastPage={isLastPage}/>
            <View></View>
          </ScrollView>
        </View>
      </View>
    </Sensor>;
}
export default ListContainer;
